import VideoJsAdapter  from "../../adapters/videojs_adapter";

export default class FullscreenToggle extends VideoJsAdapter.getComponent('FullscreenToggle') {
  constructor(player, options = {}){
    super(player, options);

    if(!this.options_.show) this.hide();
  }
}

VideoJsAdapter.registerComponent('FullscreenToggle', FullscreenToggle);

